import { EnumRetryArgumentName, ErrorCodes, IApiArgument } from "config";

import { reduce } from "lodash-es";
import { DateTime } from "luxon";

export const POLLING_ERROR_CODES: ErrorCodes[] = [
  "APPLICATION_DOCUMENT_NOT_READY",
  "DYNAMIC_FORMS_POLLING",
];

type RetrySourceArguments = ReturnType<typeof getRetrySources>;
type RetryArguments = Pick<RetrySourceArguments, "retryBackoffFactor" | "retryDelay"> & {
  retryCount?: number;
};

export const buildPollingInterval = ({
  retryBackoffFactor = 0.25,
  retryDelay = 0.5,
  retryCount = 0,
}: RetryArguments) => {
  const backoff = retryBackoffFactor * retryCount;
  const retryDelayTime = retryDelay + backoff;
  return retryDelayTime * 1000;
};

export const getRetrySources = (apiArguments: IApiArgument[]) => {
  const retryOptions = reduce(
    apiArguments || [],
    (retry, argument) => {
      const argumentName = argument.name as EnumRetryArgumentName;
      const argumentValue = parseFloat(argument.source);

      if (retry[argumentName] !== undefined && Number.isFinite(argumentValue)) {
        retry[argumentName] = argumentValue;
      }

      return retry;
    },
    {
      retryBackoffFactor: 0.25,
      retryDelay: 0.5,
      retryTimeout: 300,
    }
  );

  return retryOptions;
};

export const hasExpiredRetryTimeout = (startTime: DateTime, retryTimeout: number) => {
  const currentTime = DateTime.local();
  return currentTime.diff(startTime, "seconds").seconds >= retryTimeout;
};
